import React, { Component } from 'react';
import {connect} from 'react-redux';
import {cekCookies} from '../../../../actions';
import __ from 'lodash';
import Loader from '../../../Loader';
import LoaderModal from '../../../modal/LoaderModal';
import Navbar from '../../navbar/Navbar';
import Sidebar from '../../sidebar/Sidebar';
import { CONFIG } from '../../../../config';
import accountManagement from '../../../../apis/accountManagement';
import { Alert } from 'react-bootstrap';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import AddEditHw from './AddEditHw';
import QuestionAnswerOutlinedIcon from '@material-ui/icons/QuestionAnswerOutlined';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import CreateOutlinedIcon from '@material-ui/icons/CreateOutlined';
import {Link} from 'react-router-dom';

class Homework extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isFetching: false,
            isLoading: false,
            listHw: [],
            alertShow: false,
            resMessage: null,
            params: {},
            isAddHw: false,
            setProfilId: null,
            openDialog: false,
            selectedProfil: {}
        };
    }

    async componentDidMount() { 
        document.title = "Homework";
        this.setState({ isFetching: true});
        await this.props.cekCookies();    
        if(!__.isEmpty(this.props.account)) {
            this.setState({
                params: {
                    idSekolah: this.props.account.idSekolah,
                    idGuru: this.props.account.idGuru,
                    search: null 
                }
            })
            this.fetchHw();
        } 
        this.setState({ isFetching: false});   
        
        
    }

    fetchHw = async() => {
        this.setState({ isLoading: true, listHw:[] });
        const res = await accountManagement.get(CONFIG.HW_LIST ,{
            params: this.state.params
        }).catch(function(error){ console.log(error) });
        
        if (res) {
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({ listHw: res.data.data });  
            } else {
                this.setState({ listHw: [] });  
            }
            
            this.setState({ isLoading: false});          
        }
        this.setState({ isLoading: false });
    }

    handleBack = async() => { this.setState({isAddHw: false}) }

    handleSearch = async(e) => {
        const {params} = this.state;
        let value = e.target.value;
        if(value === "") {
            this.setState({ params : {...params, ['search']: null} })
        }        
        else {
            this.setState({ params : {...params, ['search']: value} })
        }

        this.fetchHw();
        
    }

    handleAddEdit(id) {
        this.setState({
            setProfilId: id,
            isAddHw: true
        }) ;

    }

    onDelete = async() => {
        //console.log('del',data.idProfilCbt)
        this.setState({ isLoading: true })
        const { listHw, selectedProfil } = this.state;         
        const json = { 'id' : selectedProfil.idProfilCbt}
        const resDelete = await accountManagement.post(CONFIG.EXAM_DELETE, json)
            .catch(function(error){
                this.setState({error});
            });
        
        if (resDelete) {
            if(resDelete.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({ 
                    openDialog: false,
                    alertShow:true,
                    resMessage: resDelete.data.errorSchema.errorMessage +"... DELETED " + selectedProfil.namaProfil,
                    listHw: listHw.filter(profil => profil.idProfilCbt !== selectedProfil.idProfilCbt),
                    selectedProfil: {}
                });
            }
        }      
        this.setState({isLoading: false })
    }


    render() {
        const {listHw} = this.state;
        let addEditHw;        
        if(this.state.isAddHw) {
            addEditHw = <AddEditHw onFormSubmit={this.onFormSubmit} handleBack={this.handleBack} idProfilCbt={this.state.setProfilId} />
        }

        return (
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching}/> 
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar title={'Homework'}/> 
                    {!addEditHw &&
                    <div className="container-fluid">                         
                        {this.loadAlert()}  
                        

                        <div className="row">
                            <div className="col-sm-6">    
                                <button className="btn btn-primary" onClick={() => this.handleAddEdit(null) }> Add Homework </button>&nbsp;
                            </div>

                            <div className="col-sm-6 ">
                                <input type="text" className="form-control pull-right" style={{width:'60%'}} placeholder="search homework ..." 
                                    onKeyUp={this.handleSearch} />
                            </div>

                        </div>
                        {this.loading()}
                        {!this.state.isLoading &&
                        <div className="mt-2">      
                            {listHw.map((data, i) =>
                            <div className="card" style={{marginBottom: '5px'}} key={i}>
                                <div className="card-header">                    
                                    <div className="row">
                                        <div className="col-sm-3 col-xs-3">                        
                                            {i+1}. <span>{data.namaProfil}   </span>               
                                        </div>

                                        <div className="col-sm-3 col-xs-3">
                                            {data.namaSubProfil}
                                        </div>

                                        <div className="col-sm-3 col-xs-3">
                                            {data.namaKelas}
                                        </div>

                                        <div className="col-sm-1 col-xs-1">
                                            <small>{data.jumlahSoal} Soal </small>
                                        </div>

                                        <div className="col-sm-2 col-xs-2">
                                            <ButtonGroup size="small" color="default" aria-label="small outlined button group">
                                                <Button title="Manage Soal">
                                                    <Link to={{pathname: "/examsoal/" + data.idSubProfilCbt + "/homework" }}><QuestionAnswerOutlinedIcon color="primary" /></Link>
                                                </Button>
                                                <Button title="Edit Homework" onClick={() => this.handleAddEdit(data.idProfilCbt) } >
                                                    <CreateOutlinedIcon />
                                                </Button>
                                                <Button title="Hapus Homework"  onClick={() => this.handleDialog(data)} disabled>
                                                    <DeleteForeverOutlinedIcon color="error" />
                                                </Button>
                                            </ButtonGroup>
                                            {/*<div className="btn-group" style={{width:'100%'}}>
                                                 <button className="btn btn-outline-primary btn-sm dropdown-toggle" data-toggle="dropdown">
                                                    Manage
                                                </button> *<div className="dropdown-menu">
                                                    <Link to={{ pathname: "/examsoal/" + data.idSubProfilCbt + "/homework" }} >
                                                        <button className="btn dropdown-item" >Manage Soal</button>
                                                    </Link>
                                                    
                                                    <div className="dropdown-divider"></div>
                                                    <button className="btn dropdown-item" onClick={() => this.handleAddEdit(data.idProfilCbt) }>Edit</button>
                                                    <div className="dropdown-divider"></div>
                                                    <button className="btn dropdown-item" onClick={() => this.handleDialog(data)}>Hapus</button>
                                                </div> 
                                            </div>     */}                                       
                                        </div>
                                    </div>
                                </div>
                            </div>
                            )}   
                        </div> 
                        }
                    </div>
                    }
                    {addEditHw}
                    {this.confirmDialog()}
                </div>
            </div>    
        );
    }

    loading = () =>{
        if(this.state.isLoading){
            return(
                <Loader />
            )
        }
    }
    loadAlert = () => {
        const {alertShow } = this.state;
      
        if (alertShow) {
          return (
            <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>   
                <strong>{this.state.resMessage}</strong>
            </Alert>
          );
        } 
    }  

    handleDialog = (data) => {
        this.setState({
            openDialog: true,
            selectedProfil: data
        })
    }

    confirmDialog() {        
        const {openDialog, selectedProfil} = this.state;  
        const handleClose = () => { this.setState({openDialog: false, selectedProfil: {}}) };        
        return (            
            <Dialog
                open={openDialog}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">Konfirmasi Hapus Homework ?</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Menghapus Profil Homework juga akan menghapus Jadwal & report Siswa<br/>
                        Yakin akan menghapus Profil <strong>{selectedProfil.namaProfil}</strong> ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <button className="btn btn-danger" onClick={handleClose}> Tidak </button>
                    <button className="btn btn-success" onClick={() => this.onDelete(selectedProfil.idProfilCbt)} autoFocus> Ya </button>                  
                </DialogActions>
            </Dialog>            
        )
    }  
}

const mapStateToProps = (state) => {
    return{
        account: state.account       
    };
}

export default connect(mapStateToProps, {cekCookies})(Homework); 